export enum EPreset {
  TODAY = 'TODAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}
export enum ESort {
  ByPayments = 'ByPayments',
  ByTime = 'ByTime',
}

export type TActiveClient = {
  nickname: string;
  payments: number;
  total_seconds: number;
  last_client_activity: string;
  avatar_url: string;
  roles: {
    alias: string;
  }[];
};

export interface IGetActiveClientsRequest {
  input: {
    from?: string;
    to?: string;
    preset?: EPreset;
    sort: ESort;
  };
  first?: number;
}
export interface IGetActiveClientsResponse {
  getActiveClientList: Array<TActiveClient>;
}

export interface IGetActiveWorkShift {
  activeWorkShift: {
    created_at: string;
  };
}
